import React, { Suspense, FC, memo } from 'react';
import { BemMethod, createBem } from '@om-fe/utils';
import Overlay from '@om-fe/core/components/overlay/overlay';
import { useLang } from '@om-fe/widgets/dist/common/i18n/i18n.hooks';

const bem: BemMethod = createBem('TaxesModal');

interface BetslipTaxesInfoModal {
    readonly opened: boolean;
    readonly onClose: () => void;
}

const taxesMap: Record<string, React.ComponentType<Partial<BetslipTaxesInfoModal>>> = {
    en: React.lazy(() => import('./betslip-taxes-info-modal-en')),
    el: React.lazy(() => import('./betslip-taxes-info-modal-el')),
};

export const TaxesInfoModal: FC<BetslipTaxesInfoModal> = memo(function TaxesInfoComponent(
    {
        opened,
        onClose,
    }: BetslipTaxesInfoModal,
) {
    const lang = useLang();
    const TaxesInfoComponent: React.ComponentType<Partial<BetslipTaxesInfoModal>> | undefined = taxesMap[lang];

    if (!TaxesInfoComponent) {
        return null;
    }

    return (
        <Overlay
            opened={opened}
            onClose={onClose}
        >
            <div className={bem('TaxesInfo')}>
                <Suspense fallback={null}>
                   <TaxesInfoComponent onClose={onClose} />
                </Suspense>
            </div>
        </Overlay>
    )
});

